import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <UpdatesSection />
        <RankingSection />
        <FaqSection />
        <ContactSection />
        <CardsSection />
        <CommentsSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}